import { BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { Toaster } from 'sonner'

import { SWRProvider } from '@/lib/config/swr-config'
import { AnalyticsProvider } from '@/lib/config/analytics-provider'
import { AuthProvider } from '@/lib/config/auth-provider'
import { PylonProvider } from '@/lib/config/pylon-provider'
import { BrandProvider } from '@/lib/brand-provider'
import { ThemeProvider } from '@/lib/theme-provider'

import { AppRoutes } from '@/routes/AppRoutes/AppRoutes'
import { AppLightboxLabelsProvider } from '@/features/studies/report/page/components/deck/deckChromeLabels'
import { ChatCrashRestore } from '@/pages/ChatPage/ChatCrashRestoreWatcher'
import { SpaRootLayoutEffects } from './layouts/SpaRootLayoutEffects'
import '@/i18n'

export function SpaApp() {
  return (
    <BrowserRouter>
      <HelmetProvider>
        <AnalyticsProvider>
          <ChatCrashRestore />
          <AuthProvider>
            <ThemeProvider defaultTheme="light">
              <PylonProvider>
                <BrandProvider>
                  <SWRProvider>
                    <SpaRootLayoutEffects />
                    <AppLightboxLabelsProvider>
                      <AppRoutes />
                    </AppLightboxLabelsProvider>
                    <Toaster
                      position="top-center"
                      closeButton
                      toastOptions={{
                        className: 'ds-toast',
                        classNames: {
                          success: 'ds-toast-success',
                          error: 'ds-toast-error',
                          warning: 'ds-toast-warning',
                          info: 'ds-toast-info',
                        },
                      }}
                    />
                  </SWRProvider>
                </BrandProvider>
              </PylonProvider>
            </ThemeProvider>
          </AuthProvider>
        </AnalyticsProvider>
      </HelmetProvider>
    </BrowserRouter>
  )
}
